import { useMemo } from 'react';
import { resolveScaleNotes, ScaleNote } from '../utils/scaleNotes';
import { ScaleId } from '../data/scales';

export interface ResolvedScale {
  rootNote: string;
  scaleId: ScaleId;
  notes: ScaleNote[];
}

export function useScale(rootNote: string | null, scaleId: ScaleId | null): ResolvedScale | null {
  return useMemo(() => {
    if (!rootNote || !scaleId) return null;
    return {
      rootNote,
      scaleId,
      notes: resolveScaleNotes(rootNote, scaleId),
    };
  }, [rootNote, scaleId]);
}
